import { useNavigate } from 'react-router';
import { Box, Button, OutlinedInput } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import SearchLoader from '../SearchLoader';

const Toolbar = ({ route, filterItem, searchLoader, text, ...props }) => {
  const navigate = useNavigate();
  const Navigate = () => {
    navigate(route);
  };
  return (
    <Box {...props}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'space-between'
        }}
      >
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            width: '17%'
          }}
        >
          <OutlinedInput
            size="small"
            id="search"
            fullWidth
            type="text"
            placeholder="Search"
            startAdornment={
              <SearchIcon sx={{ height: '20px', color: '#a5aebb' }} />
            }
            endAdornment={searchLoader && <SearchLoader />}
            onChange={(e) => {
              filterItem(e.target.value);
            }}
          />
        </Box>

        <Button
          sx={{
            textTransform: 'none',
            height: '80%',
            transition: '.5s',
            opacity: '.9',
            '&:hover': {
              opacity: '1',
              transform: 'scale(.9)'
            }
          }}
          color="primary"
          variant="contained"
          onClick={Navigate}
        >
          {text}
        </Button>
      </Box>
    </Box>
  );
};

export default Toolbar;
